export default "__VITE_ASSET__c9d59bb9__"